import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

import New_C_Sign_In_2025 from "../components/New_C_Sign_In_2025";
import New_C_Header_2025 from "../components/New_C_Header_2025";
import New_C_Footer_2025 from "../components/New_C_Footer_2025";
import New_C_Footer_2025_V2 from "../components/footer_automatic_files/Layout";
import New_C_Footer_Without_Testimony_2025_V2 from "../components/footer_automatic_files/Layout_Without_Testimony";
import New_C_Header_2025_V2 from "../components/header_automatic_files/Header";

import New_Navigation_2025 from "../components/New_Navigation_2025";


import New_C_A_Propos_2025 from "../components/a_propos_automatic_files/new_a_propos";

import New_Homepage_2025 from "../components/homepage_automatic_files/new_homepage";

const new_p_home_page_2025 = () => {


  return (
    <div>
    
      <Helmet>
        <title>Éditeur Français de logiciels de gestion pour organismes de formation - Gestion administrative, CRM, E-Learning, Marketplace</title>
        <meta name="description" content="Éditeur Français de logiciels pour organismes de formation. Avec notre solution Tout-en-Un, Nous automatisons les étapes Qualiopi (Inscription, Documents personnalisés, Les émargements sécurisés, Les évaluations, etc). Votre Le bilan pédagogique et financier est généré automatiquement." />
        <meta name="robots" content="index,follow" />
        <meta name="title" content="Éditeur Français de logiciels de gestion pour organismes de formation - Gestion administrative, CRM, E-Learning, Marketplace" />
        <link rel="canonical" href={window.location.href} />

      </Helmet>

      <New_Navigation_2025 />
      <New_C_Header_2025_V2 />

      <New_Homepage_2025 />

      <New_C_Footer_2025_V2 />

    </div>

  )
}


export default new_p_home_page_2025;
